import { memo } from "react";

import { Handle, NodeProps, Position } from "@xyflow/react";



import styles from "./NoteWorkflows.module.css";

import { WorkflowNodeData } from "./workflowsToFlow";



function truncate(text: string, maxLength: number): string {

    const trimmed = text.trim();

    if (!trimmed) {

        return "";

    }

    if (trimmed.length <= maxLength) {

        return trimmed;

    }

    return `${trimmed.slice(0, maxLength - 1)}…`;

}



function WorkflowNodeComponent({ data }: NodeProps) {

    const nodeData = data as WorkflowNodeData;

    const title = truncate(nodeData.title, 80);

    const preview = truncate(nodeData.description, 80);

    const kindClass =
        nodeData.nodeKind === "trigger"
            ? styles.nodeTrigger
            : nodeData.nodeKind === "step"
              ? styles.nodeStep
              : nodeData.nodeKind === "subflow"
                ? styles.nodeSubflow
                : nodeData.nodeKind === "subflow_step"
                  ? styles.nodeSubflowStep
                  : styles.nodeOutcome;



    return (

        <div className={`${styles.workflowNode} ${kindClass} ${nodeData.selected ? styles.nodeSelected : ""}`}>

            <Handle id="left" type="target" position={Position.Left} className={styles.nodeHandle} />

            {title ? <div className={styles.nodeTitle}>{title}</div> : null}

            <div className={styles.nodeDescription}>{preview || "…"}</div>

            <Handle id="right" type="source" position={Position.Right} className={styles.nodeHandle} />

            {nodeData.nodeKind === "trigger" && (
                <Handle id="bottom" type="source" position={Position.Bottom} className={styles.nodeHandle} />
            )}

        </div>

    );

}



export const WorkflowNode = memo(WorkflowNodeComponent);

